import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU, Money_ByCurrency, Currency_$reflection, SKU_$reflection, Money_$reflection } from "./Common.js";
import { int32_type, class_type, record_type, option_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { unwrap, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";

export class RetailPrice extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Regular", "SoldOut"];
    }
}

export function RetailPrice_$reflection() {
    return union_type("Shopfoo.Domain.Types.Sales.RetailPrice", [], RetailPrice, () => [[["price", Money_$reflection()]], []]);
}

export function RetailPrice__ToOption(this$) {
    if (this$.tag === 1) {
        return undefined;
    }
    else {
        return this$.fields[0];
    }
}

export class Prices extends Record {
    constructor(SKU, Currency, RetailPrice, ListPrice) {
        super();
        this.SKU = SKU;
        this.Currency = Currency;
        this.RetailPrice = RetailPrice;
        this.ListPrice = ListPrice;
    }
}

export function Prices_$reflection() {
    return record_type("Shopfoo.Domain.Types.Sales.Prices", [], Prices, () => [["SKU", SKU_$reflection()], ["Currency", Currency_$reflection()], ["RetailPrice", RetailPrice_$reflection()], ["ListPrice", option_type(Money_$reflection())]]);
}

export function Prices_Create_79A27D29(sku, currency, retailPrice, listPrice) {
    return new Prices(sku, currency, new RetailPrice(0, [Money_ByCurrency(currency, retailPrice)]), map((value_1) => Money_ByCurrency(currency, value_1), listPrice));
}

export function Prices_Create_Z30CEE70E(isbn, currency, retailPrice, listPrice) {
    return Prices_Create_79A27D29(Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU(isbn), currency, retailPrice, unwrap(listPrice));
}

export function Prices_Initial_3006DE4A(sku, currency) {
    return new Prices(sku, currency, new RetailPrice(1, []), undefined);
}

export class Sale extends Record {
    constructor(SKU, Date$, Price, Quantity) {
        super();
        this.SKU = SKU;
        this.Date = Date$;
        this.Price = Price;
        this.Quantity = (Quantity | 0);
    }
}

export function Sale_$reflection() {
    return record_type("Shopfoo.Domain.Types.Sales.Sale", [], Sale, () => [["SKU", SKU_$reflection()], ["Date", class_type("System.DateOnly")], ["Price", Money_$reflection()], ["Quantity", int32_type]]);
}

export class SalesStats extends Record {
    constructor(LastSale, QuantityOver1Y, TotalOver1Y) {
        super();
        this.LastSale = LastSale;
        this.QuantityOver1Y = (QuantityOver1Y | 0);
        this.TotalOver1Y = TotalOver1Y;
    }
}

export function SalesStats_$reflection() {
    return record_type("Shopfoo.Domain.Types.Sales.SalesStats", [], SalesStats, () => [["LastSale", option_type(Sale_$reflection())], ["QuantityOver1Y", int32_type], ["TotalOver1Y", option_type(Money_$reflection())]]);
}

export function SalesStats_get_Empty() {
    return new SalesStats(undefined, 0, undefined);
}

